export const LOGIN = {
  ADMIN_APP_LOGIN : 'ADMIN_APP_LOGIN'
}

export const NAVIGATION = {
  TRANSFER_TO_HOSP              : 'TRANSFER_TO_HOSP',
  TRANSACTION_SETTLEMENT_QR     : 'TRANSACTION_SETTLEMENT_QR',
  HOSPITAL_MASTER_DATA          : 'HOSPITAL_MASTER_DATA',
  INSTITUTION_DASHBOARD         : 'INSTITUTION_DASHBOARD',
  INSTITUTION_EMPLOYEE_DETAILS  : 'INSTITUTION_EMPLOYEE_DETAILS',
  MY_PROFILE                    : 'MY_PROFILE',
  CHANGE_PASSWORD               : 'CHANGE_PASSWORD',
  APPOINTMENT_BOOKING           : 'APPOINTMENT_BOOKING',
  LOCATIONS                     : 'LOCATIONS',
  POS_TRANSACTIONS              : 'POS_TRANSACTIONS',
  LAB_TESTS_BOOKING             : 'LAB_TESTS_BOOKING',
  PAYTM_TXNS                    : 'PAYTM_TXNS',
  PAYTM_TXNS_NOT_PROCESSED      : 'PAYTM_TXNS_NOT_PROCESSED',
  PAYTM_TXNS_PROCESSED          : 'PAYTM_TXNS_PROCESSED',
  PAYTM_TXNS_OPEN_TRANSACTION   : 'PAYTM_TXNS_OPEN_TRANSACTION',
  PAYTM_TXNS_FAILED_TRANSACTION : 'PAYTM_TXNS_FAILED_TRANSACTION',
  PAYTM_TXNS_PROCESS_DIALOG     : 'PAYTM_TXNS_PROCESS_DIALOG',
  KPI_DASHBOARD                 : 'KPI_DASHBOARD',
   LOAN_LEADS                   : 'LOAN_LEADS',
  
} 

export const TRANSFER_TO_HOSP = {
  TRANSFERRED_LIST     : 'TRANSFERRED_LIST',
  NOT_TRANSFERRED_LIST : 'NOT_TRANSFERRED_LIST',
  TRANSFER_TXNS        : 'TRANSFER_TXNS'
}

export const TRANSACTION_SETTLEMENT_QR = {
  PROCESS_TRANSFER     : 'PROCESS_TRANSFER',
  MARKED_FOR_FTR       : 'MARKED_FOR_FTR',
  TRANSFER_HISTORY     : 'TRANSFER_HISTORY'
}

export const HOSPITAL_MASTER_DATA = {
  ADDITIONAL_DETAILS_DIALOG : 'ADDITIONAL_DETAILS_DIALOG',
  ADDITIONAL_DETAILS_UPDATED : 'ADDITIONAL_DETAILS_UPDATED',
  BONUS_CASH_DIALOG : 'BONUS_CASH_DIALOG',
  BONUS_CASH_UPDATED : 'BONUS_CASH_UPDATED',
  CASHBACK_DETAILS_DIALOG : 'CASHBACK_DETAILS_DIALOG',
  CASHBACK_DETAILS_UPDATED : 'CASHBACK_DETAILS_UPDATED',
  FACILITIES_DIALOG : 'FACILITIES_DIALOG',
  FACILITIES_UPDATED : 'FACILITIES_UPDATED',
  HOSPITAL_LOCATION_DIALOG : 'HOSPITAL_LOCATION_DIALOG',
  HOSPITAL_LOCATION_UPDATED : 'HOSPITAL_LOCATION_UPDATED',
  INSURANCE_VENDOR_DIALOG : 'INSURANCE_VENDOR_DIALOG',
  INSURANCE_VENDOR_UPDATED : 'INSURANCE_VENDOR_UPDATED',
  KIT_DETAILS_DIALOG : 'KIT_DETAILS_DIALOG',
  KIT_DETAILS_UPDATED : 'KIT_DETAILS_UPDATED',
  PAYOUT_DETAILS_DIALOG : 'PAYOUT_DETAILS_DIALOG',
  PAYOUT_DETAILS_UPDATED : 'PAYOUT_DETAILS_UPDATED',
  REMARKS_DIALOG : 'REMARKS_DIALOG',
  REMARKS_UPDATED : 'REMARKS_UPDATED',
  SPECIALIZATIONS_DIALOG : 'SPECIALIZATIONS_DIALOG',
  SPECIALIZATIONS_UPDATED : 'SPECIALIZATIONS_UPDATED',
  UPLOAD_FILE_DIALOG : 'UPLOAD_FILE_DIALOG',
  UPLOAD_FILE_UPDATED : 'UPLOAD_FILE_UPDATED',
  VIEW_FILE_DIALOG : 'VIEW_FILE_DIALOG'
}
export const APPOINTMENT_BOOKING = {
  CONFIRM_APPOINTMENT : 'CONFIRM_APPOINTMENT',
  CANCEL_APPOINTMENT  : 'CANCEL_APPOINTMENT',
  RESCHEDULE_APPOINTMENT : 'RESCHEDULE_APPOINTMENT',
  ATTENDED : 'ATTENDED',
  PATIENT_NO_SHOW : 'PATIENT_NO_SHOW'
}

export const LOCATIONS = {
  CITY                : 'CITY',
  LOCATION            : 'LOCATION',
  REGION              : 'REGION',
  ZONE                : 'ZONE',
  ADD_CITY            : 'ADD_CITY',
  UPDATE_CITY         : 'UPDATE_CITY',
  ADD_LOCATION        : 'ADD_LOCATION',
  UPDATE_LOCATION     : 'UPDATE_LOCATION',
  ADD_ZONE            : 'ADD_ZONE',
  UPDATE_ZONE         : 'UPDATE_ZONE',
  BULK_LOCATION_UPLOAD: 'BULK_LOCATION_UPLOAD'
}

export const POS_TRANSACTIONS = {
  PROCESS_TRANSACTION : 'PROCESS_TRANSACTION',
  UPDATE_TID          : 'UPDATE_TID'
}